import { ReferringDoctor } from "@salud/Autorizaciones/Formulario/Types/referring-doctor.enum";

import { Afiliado } from "./afiliado.entity";
import { DiagnosticoARS } from "./diagnosticoARS.entity";
import { MedicoARS } from "./medicoARS.entity";
import { OrigenARS } from "./origenARS.entity";
import { PrestacionAgregarDto, PrestacionARS } from "./prestacionARS.entity";
import { ServicioARS } from "./servicioARS.entity";

export class Autorizacion {
  public numeroCaso?: string;
  public idInteraccion?: number;
  public IdInteraccion?: number;
  public Numero?: number | string;
  public afiliado?: Afiliado;
  public identificacion?: string;
  public servicio?: ServicioARS;
  public CodigoEstado?: number;
  public fecha?: Date;

  public origen?: OrigenARS;
  public medicoTratante?: MedicoARS;
  public medicoRemitente?: ReferringDoctor;
  public diagnostico?: DiagnosticoARS;

  public telefono?: string;
  public correo?: string;
  public ValorReclamado?: number;
  public DescripcionServicio?: string;
  public DescripcionDiagnostico?: string;
  public prestaciones?: PrestacionARS[];
  public Cedula?: string | number;
  public NumeroAfiliado?: string | number;
  public NombresAfiliado?: string | number;
  public historialDeEstados: AutorizacionEstado[];
  public CantidadProcedimientos: number | string;
}

export class AutorizacionAgregarDto {
  public casoAutorizacion?: string;

  public numeroAfiliado?: string;
  public codigoServicio?: string;

  public codigoOrigen?: string;
  public codigoMedicoTratante?: string;
  public codigoMedicoRemitente?: string;
  public codigoDiagnostico?: string;

  public telefonoAfiliado?: string;
  public correoElectronicoAfiliado?: string;

  public prestaciones?: PrestacionAgregarDto[];
}

export class AutorizacionEstado {
  public Id?: string | number;
  public Fecha?: Date | string;
  public CodigoEstado?: string | number;
  public DescripcionEstado?: string;
  public CodigoEstadoAnterior?: number;
  public DescripcionEstadoAnterior?: string;
  public CodigoCausal?: number;
  public DescripcionCausal?: string;
  public CodigoUsuario?: string;
  public Observacion?: string;
}
